/**
 * @author ESTECO CSA Team <csa@esteco.com>
 */
export enum GridAlignment {
    MIDDLE = 'l-grid--middle',
    BOTTOM = 'l-grid--bottom',
    TOP = 'l-grid--top'
}
